import { Box, Tab, Tabs } from "@mui/material";
import CaloriesStats from "./Calories";
import HeartStats from "./Heart";
import StepsStats from "./Steps";
import WeightStats from "./WeightStats";
import { useSelector } from "react-redux";
import { useState } from "react";
import CustomTabPanel from "./CustomTabPanel/CustomTabPanel";
import { isEmptyObj } from "utils/HelperFunctions";
import { CommonTexts } from "locale/es";
import Messages from "pages/Messages/Messages";
import Notes from "pages/Notes/Notes";
import PatientContent from "pages/Content/Patients/PatientContent";
import DisplayPatientForm from "pages/FormsConfiguration/Patients/DisplayPatientForm";
import Reports from "pages/Reports/Reports";
import { useLocation } from "react-router-dom";

const Dashboard = () => {
  const location = useLocation();

  const tabIndexFromState = location.state?.tabIndex;
  const [value, setValue] = useState(tabIndexFromState || 0);
  const selectedCenter = useSelector(({ center }) => center)?.data;

  const patientDataObj = useSelector(({ patient }) => patient);

  const allHealthDataTypes = ["steps", "calories", "HR", "weight"];
  const healthDataTypes = selectedCenter?.configuration?.healthDataTypes
    ? selectedCenter.configuration.healthDataTypes.split(",")
    : allHealthDataTypes;

  const isStepsStats = healthDataTypes.includes("steps");
  const isCaloriesStats = healthDataTypes.includes("calories");
  const isHeartStats = healthDataTypes.includes("HR");
  const isWeightStats = healthDataTypes.includes("weight");

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {!isEmptyObj(patientDataObj) && (
        <Box id='dashboard' sx={{ width: "100%", mt: 4 }}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label='basic tabs example'
            >
              <Tab label={CommonTexts.HEALTH_DATA} {...a11yProps(0)} />
              <Tab label={CommonTexts.FORMS} {...a11yProps(1)} />
              <Tab label={CommonTexts.CONTENT} {...a11yProps(2)} />
              <Tab label={CommonTexts.MESSAGES} {...a11yProps(3)} />
              <Tab label={CommonTexts.REPORT} {...a11yProps(4)} />
              <Tab label={CommonTexts.NOTES} {...a11yProps(5)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            {isStepsStats && <StepsStats />}
            {isCaloriesStats && <CaloriesStats />}
            {isHeartStats && <HeartStats />}
            {isWeightStats && <WeightStats />}
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <DisplayPatientForm />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <PatientContent isDashboard={true} isDashboardView/> 
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <Messages isDashboard={true} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={4}>
            <Reports isDashboard={true} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={5}>
            <Notes isDashboard={true} />
          </CustomTabPanel>
        </Box>
      )}
    </>
  );
};

export default Dashboard;